import React from 'react';
import { useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label } from 'recharts';

// const data = [
//   {
//     name: '-2 day',
//     uv: 4000
//   },
//   {
//     name: '-1 day',
//     uv: 3000
//   },
//   {
//     name: 'Today',
//     uv: 2000
//   }
// ];

export const AreaChartComponent = (props) =>{
    const [data, setData] = useState(props?.data);
    
    const toKValues = (value) => {
      if(value === 0){
        return '';
      } else if(value > 999 && value < 9999){
        return value.toString().charAt(0) + 'k';
      } else {
        return value;
      }
    }

    return (
      <ResponsiveContainer>
        <AreaChart
          data={data}
          margin={{
            top: 10,
            right: 40,
            left: !props?.big ? -40 : 0,
            bottom: 10,
          }}
        >
          <CartesianGrid vertical={false}/>
          <XAxis dataKey="name" fontSize='0.4vw' padding={{ left: 20, right: 20}} tick={{ fontSize: 25 }} tickMargin={10}/>
          <YAxis dataKey="value" tickLine={0} axisLine={0} fontSize='0.4vw' interval={0} tickMargin={0} width={!props?.big ? 140 : 60} tickFormatter={toKValues}>
            <Label value={props?.chartLabel} angle={-90} position='' fontSize='30px' style={{display: !props?.big ? 'block' : 'none'}}/>
          </YAxis>
          <Tooltip />
          <Area type="monotone" dataKey="value" stroke="#0b7571" fill="#e7f7f8" fillOpacity={0.8} dot={{ stroke: '#0b7571', strokeWidth: 4, r: 2, fill: '#0b7571'}}/>
        </AreaChart>
      </ResponsiveContainer>
    );
}

const CustomYAxisTick= ({ x, y, payload }) => {
    return (<text>{payload.value}</text>);
}